export default __webpack_public_path__ + "static/media/clientes4.e00253a7.png";